import { render, staticRenderFns } from "./PaymentMethodChangeActivationType.vue?vue&type=template&id=bdb902f2&"
import script from "./PaymentMethodChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports